import { useWatch } from 'react-hook-form';
import { TreeField } from '@mews-commander/form';
import { ContentSection } from '@mews-commander/ui';
import { Stack, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { useAccountingCategoryTreeOptions } from '../../queries/useAccountingCategoryTreeOptions';
import { useActiveAccountingCategories } from '../../queries/useActiveAccountingCategories';
import { OptionsSelectField } from '../fields/OptionsSelectField';
import { PromotionsSelectField } from '../fields/PromotionsSelectField';

export const AllowanceOptionsStepFields = () => {
    const options = useAccountingCategoryTreeOptions();
    const accountingCategories = useActiveAccountingCategories();

    const selectedAccountingCategories = useWatch({ name: 'permittedAccountingCategoryIds' });

    return (
        <Stack spacing="400" vertical>
            <ContentSection
                title={lt('AllowanceFormSectionTitlePermittedSpending')}
                description={lt('AllowanceFormSectinDescriptionPermittedSpending')}
                spacing="100"
            >
                <TreeField
                    name="permittedAccountingCategoryIds"
                    options={options}
                    multiple
                    showSearchBar
                    showSelectAllToggle
                    title={
                        <Typography variant="primary" textStyle="bodyMedium" as="div">
                            {lt('AllowanceFormOptionsTreeTitleSelected', {
                                selectedCount: selectedAccountingCategories.length,
                                totalCount: accountingCategories.length,
                            })}
                        </Typography>
                    }
                />
            </ContentSection>
            <ContentSection title={lt('Options')} spacing="300" contentSpacing="200">
                <OptionsSelectField />
                <PromotionsSelectField />
            </ContentSection>
        </Stack>
    );
};
